import styled from 'styled-components';
import { palette } from 'styled-tools';

import { maxWidth, minWidth, units } from '@calm-web/design-system';

import ChevronRightSvg from 'icons/chevron-right.svg';

export const StyledNav = styled.nav`
	justify-self: center;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: ${units(0)};

	.navButton > div {
		height: auto;
		width: auto;
	}
	.navButton[aria-disabled='true']:hover {
		cursor: not-allowed;
	}

	${minWidth('desktop')} {
		margin-top: ${units(3)};
	}

	button {
		padding: ${units(0, 1)};
	}
`;

export const NumberIcon = styled.div<{ $isActive: boolean }>`
	display: flex;
	justify-content: center;
	align-items: center;
	background: ${p => (p.$isActive ? palette('gradientCalmBrand') : palette('gray1'))};
	color: ${p => (p.$isActive ? palette('white') : palette('gray6'))};
	width: ${units(4)};
	height: ${units(4)};
	border-radius: ${units(4)};
`;

export const StepContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	${maxWidth('mobileLarge')} {
		font-size: ${units(1.75)};
	}
`;

export const ChevronRightIcon = styled(ChevronRightSvg)`
	width: ${units(2)};
	height: auto;
	margin-left: ${units(1.5)};

	${minWidth('tablet')} {
		margin-left: ${units(2.5)};
	}
`;
